






















import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import { areRoutesRegistered } from '@app/router/routeRegistration';
import { NavigationDestination } from '@app/router/types';
import {
    getAdjacentUrl,
    isExternalDestination,
} from '@app/utils/domainHelpers';

export default defineComponent({
    name: 'CustomRouterLink',
    props: {
        destination: {
            type: Object as PropType<NavigationDestination>,
            default: () => ({ name: '' }),
        },
        tag: {
            type: String,
            default: 'a',
        },
        dynamic: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        areRoutesRegistered,
    },
    setup(props) {
        const { hostname } = window.location;

        if (isExternalDestination(hostname, props.destination)) {
            return {
                absoluteUrl: getAdjacentUrl(hostname, props.destination.site, props.destination.path),
            };
        } else {
            return {
                absoluteUrl: null,
            };
        }
    },
});
